export default __webpack_public_path__ + "static/media/logo-black.058c6e80.png";